import { render, staticRenderFns } from "./guanwang.vue?vue&type=template&id=16627a58&scoped=true"
import script from "./guanwang.vue?vue&type=script&lang=js"
export * from "./guanwang.vue?vue&type=script&lang=js"
import style0 from "./guanwang.vue?vue&type=style&index=0&id=16627a58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16627a58",
  null
  
)

export default component.exports